import currency from 'currency.js';
export const getMonetaryValueOfMemberBalance = (units, paymentConversionRate) => {
    if (!paymentConversionRate)
        return undefined;
    return currency(paymentConversionRate, { precision: 10 }).multiply(units).value;
};
